import { useState } from 'react';
import CustomTextAreaInput from '../../InputFields/CustomTextAreaInput';

const TextAreaDataType = ({
  onDataChange,
  helpText,
  defaultValue,
}: {
  onDataChange: (data: any) => void;
  helpText: string;
  defaultValue: string;
}) => {
  const [formData, setFormData] = useState({
    helpText: helpText || '',
    defaultValue: defaultValue || '',
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };

    setFormData(updatedFormData);
    onDataChange(updatedFormData);
  };

  return (
    <div className="ml-4">
      <CustomTextAreaInput
        label="Help Text"
        name="helpText"
        value={formData.helpText}
        onChange={handleInputChange}
        placeholder="Enter the description. i.e - This section provides key points of contact for communication and support."
        description="This will help in guiding the person filling this field."
        rows={12}
      />
      <CustomTextAreaInput
        label="Default Value"
        name="defaultValue"
        value={formData.defaultValue}
        onChange={handleInputChange}
        rows={12}
      />
    </div>
  );
};

export default TextAreaDataType;
